import { createContext } from 'react';
import { nearestInventoryCommonState } from 'app/common/components/ItemAvailability/components/NearestAvailableButton/reducer';

export const NearestInventoryContext = createContext(
  nearestInventoryCommonState
);
